"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable:max-classes-per-file

var React = require("react");

exports.initialSecondaryStructContextRead = {
  hoveredSecondaryStructures: new Array(),
  selectedSecondaryStructures: new Array()
};
exports.initialSecondaryStructContextWrite = {
  addHoveredSecondaryStructure: function addHoveredSecondaryStructure(section) {
    return;
  },
  addSelectedSecondaryStructure: function addSelectedSecondaryStructure(section) {
    return;
  },
  clearAllSecondaryStructures: function clearAllSecondaryStructures() {
    return;
  },
  removeHoveredSecondaryStructure: function removeHoveredSecondaryStructure(section) {
    return;
  },
  removeSecondaryStructure: function removeSecondaryStructure(section) {
    return;
  }
};
exports.initialSecondaryStructureContext = __assign({}, exports.initialSecondaryStructContextWrite, exports.initialSecondaryStructContextRead);
exports.SecondaryStructureContextRead = React.createContext(exports.initialSecondaryStructContextRead);
exports.SecondaryStructureContextWrite = React.createContext(exports.initialSecondaryStructContextWrite);
exports.SecondaryStructureContext = React.createContext(exports.initialSecondaryStructureContext);
exports.SecondaryStructureContextReadConsumer = exports.SecondaryStructureContextRead.Consumer;
exports.SecondaryStructureContextWriteConsumer = exports.SecondaryStructureContextWrite.Consumer;
exports.SecondaryStructureContextConsumer = exports.SecondaryStructureContext.Consumer;

var SecondaryStructureContextProvider =
/** @class */
function (_super) {
  __extends(SecondaryStructureContextProvider, _super);

  function SecondaryStructureContextProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.onAddHoveredSecondaryStructure = function () {
      return function (section) {
        if (!_this.state.hoveredSecondaryStructures.includes(section)) {
          _this.setState({
            hoveredSecondaryStructures: __spread(_this.state.hoveredSecondaryStructures, [section])
          });
        }
      };
    };

    _this.onAddSelectedSecondaryStructure = function () {
      return function (section) {
        if (!_this.state.selectedSecondaryStructures.includes(section)) {
          _this.setState({
            selectedSecondaryStructures: __spread(_this.state.selectedSecondaryStructures, [section])
          });
        }
      };
    };

    _this.onClearSecondaryStructure = function () {
      return function () {
        _this.setState({
          hoveredSecondaryStructures: new Array(),
          selectedSecondaryStructures: new Array()
        });
      };
    };

    _this.onRemoveHoveredSecondaryStructure = function () {
      return function (sectionToRemove) {
        var prevIndex = _this.state.hoveredSecondaryStructures.findIndex(function (section) {
          return section.label === sectionToRemove.label && section.start === sectionToRemove.start && section.end === sectionToRemove.end;
        });

        _this.setState({
          hoveredSecondaryStructures: __spread(_this.state.hoveredSecondaryStructures.splice(0, prevIndex), _this.state.hoveredSecondaryStructures.splice(prevIndex + 1))
        });
      };
    };

    _this.onRemoveSecondaryStructure = function () {
      return function (sectionToRemove) {
        var prevSelectedIndex = _this.state.selectedSecondaryStructures.findIndex(function (section) {
          return section.label === sectionToRemove.label && section.start === sectionToRemove.start && section.end === sectionToRemove.end;
        });

        var prevHoveredIndex = _this.state.hoveredSecondaryStructures.findIndex(function (section) {
          return section.label === sectionToRemove.label && section.start === sectionToRemove.start && section.end === sectionToRemove.end;
        });

        _this.setState({
          hoveredSecondaryStructures: __spread(_this.state.hoveredSecondaryStructures.splice(0, prevHoveredIndex), _this.state.hoveredSecondaryStructures.splice(prevHoveredIndex + 1)),
          selectedSecondaryStructures: __spread(_this.state.selectedSecondaryStructures.splice(0, prevSelectedIndex), _this.state.selectedSecondaryStructures.splice(prevSelectedIndex + 1))
        });
      };
    };

    _this.state = {
      addHoveredSecondaryStructure: _this.onAddHoveredSecondaryStructure(),
      addSelectedSecondaryStructure: _this.onAddSelectedSecondaryStructure(),
      clearAllSecondaryStructures: _this.onClearSecondaryStructure(),
      hoveredSecondaryStructures: new Array(),
      removeHoveredSecondaryStructure: _this.onRemoveHoveredSecondaryStructure(),
      removeSecondaryStructure: _this.onRemoveSecondaryStructure(),
      selectedSecondaryStructures: new Array()
    };
    return _this;
  }

  SecondaryStructureContextProvider.prototype.render = function () {
    return React.createElement(exports.SecondaryStructureContextRead.Provider, {
      value: this.state
    }, React.createElement(exports.SecondaryStructureContextWrite.Provider, {
      value: this.state
    }, React.createElement(exports.SecondaryStructureContext.Provider, {
      value: this.state
    }, this.props.children)));
  };

  return SecondaryStructureContextProvider;
}(React.Component);

exports.SecondaryStructureContextProvider = SecondaryStructureContextProvider;